import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, Teleport as _Teleport, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_richtext_article = _resolveComponent("richtext-article")
  const _component_editor_project_carousel = _resolveComponent("editor-project-carousel")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_richtext_article, { content: $options.html }, null, 8 /* PROPS */, ["content"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.carousels, (carousel) => {
      return (_openBlock(), _createBlock(_Teleport, {
        key: carousel.id,
        to: carousel.el
      }, [
        _createVNode(_component_editor_project_carousel, {
          "search-params": carousel.searchParams,
          editable: false
        }, null, 8 /* PROPS */, ["search-params"])
      ], 8 /* PROPS */, ["to"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}